"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildingApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var buildingApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/v1/admin/building',
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: '/v1/admin/building',
      data: data,
      method: 'post'
    });
  },
  staffs: function staffs(buildingId) {
    return (0, _request.default)({
      url: "/v1/admin/building/".concat(buildingId, "/staffs")
    });
  },
  addStaff: function addStaff(buildingId, data) {
    return (0, _request.default)({
      url: "/v1/admin/building/".concat(buildingId, "/staff/add"),
      method: 'post',
      data: data
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/v1/admin/building/".concat(id, "/update"),
      method: 'post',
      data: data
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/v1/admin/building/".concat(id),
      method: 'delete'
    });
  }
};
exports.buildingApi = buildingApi;